import { renderDsInput } from '../../../../../shared-ui/ds/input.js';
import { renderDsSearch } from '../../../../../shared-ui/ds/search.js';
import { withSettingsPresentationMode } from './settingsPresentationMode.js';

export function renderSettingsInput(options = {}) {
  const nextOptions = withSettingsPresentationMode(options);
  const kind = String(nextOptions.kind || 'input').trim().toLowerCase();

  delete nextOptions.kind;

  if (kind === 'search') {
    return renderDsSearch(nextOptions);
  }

  return renderDsInput(nextOptions);
}
